module.exports = __webpack_public_path__ + "assets/img/mecha-btn-495e362c.png";